/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from '../ComponentLogger';
import ActiveListBase from './ActiveListBase';
import StringListItem from './StringListItem';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass('StringList')
export default class StringList extends ActiveListBase<string>
{
    @property({ type: [StringListItem], override: true })
    protected items: StringListItem[] = [];

    constructor(values: string[] = null)
    {
        super();

        if (values == null) { return; }
        if (this.items.length) { this.items.length = 0; }
        for (let value of values)
        {
            this.items.push(new StringListItem(value));
        }
    }
}
